import { useTranslation } from 'src/core/common/hooks/useTranslation';
import { useAccountingSoftwareName } from 'src/core/modules/accounting-integration/apis';
import { SupplierOrMemberSyncStatus } from 'src/core/modules/bookkeep/components/SupplierOrMemberSyncStatus';
import {
  getCounterpartySuppliersTitle,
  getCounterpartySuppliersTooltipText,
} from 'src/core/modules/bookkeep/payables/components/PayablePanel/translations';
import { useSupplierSyncStatus } from 'src/core/modules/suppliers/hooks';

export const SupplierSyncStatusForIntegration = ({
  supplierId,
}: {
  supplierId: string | undefined;
}) => {
  const { t } = useTranslation('global');
  const supplierSyncStatus = useSupplierSyncStatus(supplierId);
  const { integration } = useAccountingSoftwareName();

  return (
    <>
      {supplierSyncStatus.status === 'success' && (
        <div className="-mb-8">
          <SupplierOrMemberSyncStatus
            label={
              supplierSyncStatus.data.synced
                ? getCounterpartySuppliersTitle(t, integration).synced
                : getCounterpartySuppliersTitle(t, integration).notSynced
            }
            tooltipText={getCounterpartySuppliersTooltipText(t, integration)}
            {...supplierSyncStatus.data}
          />
        </div>
      )}
    </>
  );
};
